import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-production-button',
  templateUrl: './production-button.component.html',
  styleUrls: ['./production-button.component.scss'],
  standalone: false
})
export class ProductionButtonComponent {

  @Input() initDate: string = '';
  @Input() disabled: boolean = false;

  @Output() clickButton = new EventEmitter<void>();

  productionChronometer: number = 0;
  productionChronometerHours: number = 0;
  interval: any;

  get startedChronometer(): boolean {
    return this.productionChronometer > 0;
  }

  /**
   * Empieza el tiempo.
   *
   */
  public startTimer() {
    this.pauseTimer();

    const startTime = parseInt(this.initDate, 10);

    if (startTime <= 0) {
      return;
    }

    const now = Date.now();

    this.productionChronometer = now - startTime;
    this.updateChronometerHours();

    this.interval = setInterval(() => {
      this.productionChronometer += 1000;
      this.updateChronometerHours();
    }, 1000);
  }


  /**
   * Pausa el tiempo
   *
   */
  public pauseTimer() {
    clearInterval(this.interval);

    this.productionChronometerHours = 0;
    this.productionChronometer = 0;
  }


  /**
   * Actualizar las horas
   *
   */
  private updateChronometerHours() {
    this.productionChronometerHours = Math.floor(this.productionChronometer / 3600000);
  }

}
